export default {"src":"/fly/_next/static/media/carousel-arrow-right.52009538.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};